// organization-api.js
import { ProtectedHttpClient } from "../shared/clients/http-client";

const OrganizationApi = {
  private: {
    addNewUser: (payload) => ProtectedHttpClient.post("/organization/invite", payload), // Requires token
    getAllUsers: (filters = {}, paginationOptions = {}) =>
      ProtectedHttpClient.post("/users", filters, { params: paginationOptions }), // Requires token
    fetchOrganization: (organizationId) =>
      ProtectedHttpClient.get(`/organization/${organizationId}?withSecrets=true`), // Requires token
    updateOrganization: (organizationId, payload) =>
      ProtectedHttpClient.patch(`/organization/${organizationId}`, payload), // Requires token
    getWhatsappSenderDetails: (organizationId) =>
      ProtectedHttpClient.get(`/organization/${organizationId}/whatsapp-sender-details`), // Requires token
    acceptTerms: (organizationId) =>
      ProtectedHttpClient.post(`/organization/${organizationId}/accept-terms`), // Requires token
  },
};

export default OrganizationApi;
